module.exports = __webpack_public_path__ + "img/uploadC.17386441.png";